import { ref } from "vue";

const isOpen = ref(false);
const resolveFn = ref<(value: boolean) => void>();
const message = ref("");

export function useModalService() {
  function confirm(messageText: string): Promise<boolean> {
    message.value = messageText;
    isOpen.value = true;

    return new Promise<boolean>(resolve => {
      resolveFn.value = resolve;
    });
  }

  function onConfirm() {
    isOpen.value = false;
    resolveFn.value?.(true);
  }

  function onCancel() {
    isOpen.value = false;
    resolveFn.value?.(false);
  }

  return { isOpen, message, confirm, onConfirm, onCancel };
}
